
import { Button, Modal } from "react-bootstrap";
import "./create-standard-question-from-url.component.scss";
import { CircularProgress, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from 'uuid';
import { Question, QuestionLanguage } from "../../../model/questions-summary.model";
import { genQuestionByCompanyUrl, putStandardAssessment } from "../../../services/api.service";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import tokenService from "../../../services/token.service";
import AI_WHITE from "../../../assets/images/ai-icon.png"
import PLUS_PURPLE from "../../../assets/images/plus-purple.png";
import TRASH_ICON from "../../../assets/images/trash.png";
import config from "../../../config";
import { ProviderContext } from "../../../contexts/provider.context";
import useDeviceType from "../../../utils/device-type.util";

const CreateStdAssessmentFromUrl = () => {
    const location = useLocation();
    const {profileModel} : any = useContext(ProviderContext);
    const { company_id } = useParams<{ company_id: string }>();
    const [urlCompany, setUrlCompany] = useState<string>("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { isMobile, isTablet, isDesktop } = useDeviceType();
    const [isNormal, setIsNormal] = useState(false);
    const [amountQuestion, setAmountQuestion] = useState<number>(5);
    const [numberCreateQuestion, setNumberCreateQuestion] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [questionList, setQuestionList] = useState<Question[]>([]);
    const [formList, setFormList] = useState([
        { label: "กรอก URL ของเว็บไซต์บริษัทของคุณ", field: "url", value: "", is_error: true, error_message: "กรุณากรอก url" },
        { label: "จำนวนข้อคำถาม", field: "amount", value: "", is_error: true, error_message: "กรุณาเลือก จำนวนข้อ" },

    ])
    const navigate = useNavigate();

    useEffect(() => {
        if (location && location.state) {
            if (location.state.url) {
                setUrlCompany(location.state.url);
                setAmountQuestion(location.state.total_amount)
                setQuestionList(location.state.questions);
                setNumberCreateQuestion(location.state.total_question)
                setIsNormal(false);
                updateSection(location.state.url, location.state.total_amount)
            } else {
                setIsNormal(true);
                const question: Question = {
                    question_id: uuidv4(),
                    question_type: "voice",
                    question: {
                        th: "",
                        en: ""
                    },
                    created_by: tokenService.getProfile().email,
                    topic: "standard_questions"
                }
                setQuestionList(new Array(question))
                setNumberCreateQuestion(location.state.total_question)
            }

        }
    }, [location])

    const handleUpdateQuestion = (index: number, field: keyof QuestionLanguage, value: string) => {
        const updatedQuestions = [...questionList];
        updatedQuestions[index].question[field] = value;
        setQuestionList(updatedQuestions);
    };

    // Function to remove a question from the list
    const handleDeleteQuestion = (index: number) => {
        const updatedQuestions = questionList.filter((_, i) => i !== index);
        setQuestionList(updatedQuestions);
    };

    const updateSection = (url, total_amount) => {
        if (formList) {
            const formMod = [...formList];
            formMod[0].value = url;
            formMod[0].is_error = false;
            formMod[1].value = total_amount;
            formMod[1].is_error = false;
            setFormList(formMod);

        }
    }

    const clickSubmitQuestion = () => {
        if (questionList) {
            setIsSubmitting(true);
            const isFullValue = questionList.filter((item) => !item.question.en || !item.question.th);

            if (isFullValue.length > 0) {
                alert("กรอกไม่ครบ")
            } else {
                console.log(questionList);
                putStandardAssessment(company_id, questionList).then((res) => {
                    if (res.data.is_success) {
                        navigate("/" + tokenService.getHR9CompanyUUID() + "/company-questions-management");
                    }
                })
            }
        }


    };


    const addQuestion = () => {

        if (questionList) {
            const newQuestion: Question = {
                question_id: uuidv4(),
                question_type: "voice",
                question: {
                    th: "",
                    en: ""
                },
                created_by: tokenService.getProfile().email,
            }
            setQuestionList([...questionList, newQuestion]);
        } else {
            const newQuestion: Question = {
                created_by: tokenService.getProfile().email,
                question_id: uuidv4(),
                question_type: "voice",
                question: {
                    th: "",
                    en: ""
                },
            }
            setQuestionList(new Array(newQuestion));
        }
    }

    const clickToGenerateQuestion = () => {
        if (urlCompany) {
            setIsLoading(true);
            genQuestionByCompanyUrl(urlCompany, 5).then((res) => {

                if (res.data.is_success) {
                    console.log(res.data);
                    const result = res.data.message.questions as Question[];
                    setQuestionList(result);
                    setIsLoading(false);
                }
            })
        }
    }
    const handleInputChange = (event: any, field: string, index) => {
        const value = event.target.value;
        if (formList) {
            const formListMod = [...formList];
            formListMod[index].value = value;
            formListMod[index].is_error = false;
            formListMod[index].error_message = "";
            setFormList(formListMod);
        }

    };
    return (
        <div className="create-std-asm-ai-control">
            <div className="border-std create-std-asm-ai-top-control">
                <span className="create-std-asm-ai-title">สร้างคำถามพื้นฐานขององค์กร</span>
                <span className="create-std-asm-ai-sub-title">คำถามพื้นฐานขององค์กรสร้างได้สูงสุด 10 คำถาม และจะถูกนำไปใช้เมื่อสร้างชุดคำถามสัมภาษณ์</span>
                {
                    !isNormal &&
                    <div className="create-std-asm-ai-input-control">
                        {formList.map((item, index) => {
                            // Skip fields at index 6 and 7

                            const hasError = isSubmitting && item.is_error;
                            return (
                                index == 0 ?
                                    <FormControl
                                        key={index}
                                        className={`input-std create-std-asm-ai-input-form${hasError ? " input-error" : ""}`}
                                        fullWidth
                                    >
                                        <TextField
                                            id={`input-${index}`}
                                            label={item.label}
                                            variant="outlined"
                                            value={item.value}
                                            onChange={(e) => handleInputChange(e, item.field, index)}
                                        />
                                    </FormControl> :
                                    <FormControl
                                        key={index}
                                        className={`input-std create-std-asm-ai-input-form${hasError ? " input-error" : ""}`}
                                        fullWidth
                                    >
                                        <InputLabel id="demo-simple-select-label">{item.label}</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label-2"
                                            id="demo-simple-select-2"
                                            value={item.value}
                                            variant="outlined"
                                            label="เวลาในการสัมภาษณ์"
                                            className="job-position-item-input-field"
                                            onChange={(e) => handleInputChange(e, item.field, index)}
                                        >
                                            {Array.from({ length: config.questions.std_questions - numberCreateQuestion }, (_, index) => (
                                                <MenuItem value={index + 1} key={index}>
                                                    {index + 1} ข้อ
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>

                            );
                        })}
                        {
                            isDesktop && 
                            <Button className="button-std create-std-asm-ai-input-button-submit"
                            onClick={clickToGenerateQuestion}>
                            <img src={AI_WHITE} className="icon"></img>สร้างคำถามด้วย AI</Button>
                        }

                       


                    </div>
                    
                }

                {
                    !isNormal && isMobile && 
                    <Button className="button-std create-std-asm-ai-input-button-submit"
                    onClick={clickToGenerateQuestion}>
                    <img src={AI_WHITE} className="icon"></img>สร้างคำถามด้วย AI</Button>
                }

            </div>


            {
                !isLoading && questionList && questionList.length > 0 &&
                <div className="create-std-ai-question-list">

                    {
                        questionList.map((item, index) => {

                            return (
                                <div className="border-std create-std-ai-question-list-item" key={index}>
                                    {/* Thai Question Field */}
                                    <div className="create-std-form-control">
                                        <div className="create-std-topic-control">
                                            <span className="create-std-form-label">คำถามที่ {Number(index + 1)}</span>
                                            <img src={TRASH_ICON} className="icon-delete" onClick={() => handleDeleteQuestion(index)}></img>
                                        </div>
                                        <FormControl
                                            key={index}
                                            className={isSubmitting
                                                && !item.question.th ? `input-std create-std-form input-error` : `input-std create-std-form`}
                                            fullWidth
                                        >
                                            <TextField
                                                margin="dense"
                                                fullWidth
                                                variant="outlined"
                                                label="คำถามภาษาไทย"
                                                value={item.question.th}
                                                onChange={(e) => handleUpdateQuestion(index, "th", e.target.value)}
                                            />
                                        </FormControl>
                                    </div>

                                    {/* English Question Field */}
                                    <div className="create-std-form-control">
                                        <FormControl
                                            key={index}
                                            className={isSubmitting
                                                && !item.question.en ? `input-std create-std-form input-error` : `input-std create-std-form`}
                                            fullWidth
                                        >
                                            <TextField
                                                margin="dense"
                                                fullWidth
                                                variant="outlined"
                                                label="คำถามภาษาอังกฤษ"
                                                value={item.question.en}
                                                onChange={(e) => handleUpdateQuestion(index, "en", e.target.value)}
                                            />
                                        </FormControl>

                                    </div>
                                </div>
                            )
                        })
                    }
                    {
                        questionList.length != Number(config.questions.std_questions) - numberCreateQuestion &&
                        <Button className="create-std-add-question-button" onClick={addQuestion}>
                            <img src={PLUS_PURPLE} className="icon"></img>
                            <span className="text">เพิ่มคำถาม</span></Button>
                    }

                </div>
            }


            <div className="border-std create-std-sticky-footer">
                <span className="title">จำนวนคำถามที่สามารถสร้างได้: {questionList.length}/{Number(config.questions.std_questions) - numberCreateQuestion}</span>
                <div className="button-control">
                    <Button className="cancel-button">ยกเลิก</Button>
                    <Button className="button-std submit-button" onClick={clickSubmitQuestion}>สร้างคำถาม <FontAwesomeIcon icon={faChevronRight} className="icon"></FontAwesomeIcon></Button>
                </div>
            </div>



        </div>
    )


}

export default CreateStdAssessmentFromUrl;